import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { Button } from '@termly/react-components'

import Locale from './locale'
import Styles from './styles.scss'


export default function BackButton({ className, handleClick, type }) {
  const isOutline = ( type === 'outline' )

  const buttonClassName = classnames(Styles.button, className, 't-backButton', {
    [Styles.solid]: !isOutline,
  })

  const hasIcon = isOutline

  return (
    <Button
      className={ buttonClassName }
      handleClick={ handleClick }
      type={ type }
    >
      { renderIcon({ hasIcon }) }

      <FormattedMessage
        { ...Locale.back }
      />
    </Button>
  )
}

BackButton.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  type: Button.propTypes.type,
}

function renderIcon({ hasIcon }) {
  if ( !hasIcon ) {
    return null
  }

  // We inline this icon so we can style it with CSS
  return (
    <svg
      aria-hidden="true"
      height="11"
      viewBox="0 0 7 11"
      width="7"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.36.232c.424-.354 1.055-.296 1.408.128.327.391.303.959-.036 1.322l-.092.086-4.078 3.398 4.078 3.4c.392.325.47.888.203 1.306l-.075.102c-.326.391-.889.47-1.307.202l-.101-.074-5-4.167c-.448-.373-.478-1.04-.09-1.452l.09-.085 5-4.166z" />
    </svg>
  )
}
